module.exports = __webpack_public_path__ + "img/city15.1caa78c0.jpeg";